// const carouselContExists = document.querySelector(`#testimonials`);

const testimonialCardsCarousel = document.querySelector(
  `#testimonialCardCarousel`
);

const carousel = new bootstrap.Carousel(testimonialCardsCarousel, {
  interval: 10000,
  keyboard: false,
  pause: `hover`,
  touch: true,
});

/**
 * Make each testimonial visible offscreen briefly to determine the height
 */
const determineHeightOfAHiddenDivElement = (elem) => {
  elem.style.position = `absolute`;
  elem.style.top = `-5000px`;
  elem.style.display = `block`;
  const height = elem.clientHeight;
  elem.style.display = ``;
  elem.style.top = ``;
  elem.style.position = ``;
  return height;
};

/**
 * Assign the heights of each testimonial to an array for evaluation
 */
const setMaxHeightValue = (items) => {
  let carouselItemHeights = [];

  items.forEach((item) => {
    let height = determineHeightOfAHiddenDivElement(item);
    carouselItemHeights.push(height);
  });

  var maxValueInArray = Math.max.apply(Math, carouselItemHeights);

  return maxValueInArray;
};

/**
 * If Carousel exists determine the height of the biggest elem
 * and assign that to the craousel track
 */
if (testimonialCardsCarousel) {
  const carouselItems = document.querySelectorAll(
    `.testimonial-cards-container .carousel-item`
  );

  maxHeight = setMaxHeightValue(carouselItems);

  carouselItems.forEach((item) => {
    item.style.height = maxHeight + 32 + `px`;
  });
}
